module.exports = __webpack_public_path__ + "img/image_empty.f28bb80d.png";